import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ document, from, to }) =>
    present(
      repository
        .moveDocument(document, from, to)
        .then(() => ({ document, from, to }))
        .catch(() => Promise.reject({ document, from, to })),
    );
}

export type { Interactor };

export { createInteractor };
